import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var defaultTranslate = function defaultTranslate(textId) {
  return textId;
};
export var TranslationContext = React.createContext(defaultTranslate);
export var TranslationProvider = function TranslationProvider(props) {
  return ___EmotionJSX(TranslationContext.Provider, {
    value: props.translate || defaultTranslate
  }, props.children);
};
export function withTranslate(Component) {
  return function ComponentWithTranslation(props) {
    return ___EmotionJSX(TranslationContext.Consumer, null, function (translate) {
      return ___EmotionJSX(Component, _extends({}, props, {
        translate: translate
      }));
    });
  };
}